'use client'

import * as React from 'react'
import { cn } from '@/utilities/ui'
import { NavigationMenuLink } from '@/global/Header/navigation-menu'
import { Subheading } from '@/components/ui/subheading'
import { Caption } from '@/components/ui/caption'
import { AbstractNavIcon } from '@/components/icons/AbstractNavIcon'
import Link from 'next/link'

export const ListItem = React.forwardRef<
  React.ComponentRef<'a'>,
  React.ComponentPropsWithoutRef<'a'> & { icon: string }
>(({ className, title, children, icon, ...props }, ref) => {
  return (
    <NavigationMenuLink asChild>
      <Link
        {...props}
        ref={ref}
        className={cn(className, 'group/list-item p-4 hover:bg-paper-2')}
        {...props}
        href={props.href ?? ''}
      >
        <div className="flex items-center gap-[20px]">
          <div>
            <AbstractNavIcon icon={icon} />
          </div>
          <div className="flex flex-col gap-[5px] justify-center">
            <Subheading size="sm">{title}</Subheading>
            {children && <Caption className="text-olive-1">{children}</Caption>}
          </div>
        </div>
      </Link>
    </NavigationMenuLink>
  )
})

ListItem.displayName = 'ListItem'
